import React, { useEffect, useState } from 'react';
import BuscaPdvLoja from '~/components/BuscaPdvLoja';
import Loja from '~/components/Loja';
import {
  ContaBanco,
  Finalizadora,
  InputDateRange,
  InputText,
} from '~/components/NovosInputs';
import { SegmentedPicker } from '~/components/SegmentedPicker';
import { useTransferenciaDePOS } from '../../contexts/TransferenciaDePOSContext';
import { useIsWidth } from '../../hooks/useMatchWidth';
import { optionsConciliados } from '../../utils/optionsConciliados';
import { ContainerTop } from './styles';

export const ScreenFilters: React.FC = () => {
  const {
    register,
    control,
    setValue,
    loja,
    setLoja,
    emissao,
    single,
    setSingle,
    disable,
    updateEmissao,
    setResetLoja,
    resetLoja,
    keyRefDateRange,
  } = useTransferenciaDePOS();

  const isUpTo1200 = useIsWidth(1200, 'lte');

  const [pdvSelected, setPdvSelected] = useState({
    value: undefined,
    label: undefined,
  });

  useEffect(() => {
    if (resetLoja) setPdvSelected({ value: undefined, label: undefined });
  }, [resetLoja]);

  return (
    <ContainerTop>
      <div className="first-content">
        <Loja
          onChange={(value) => {
            setLoja(value);
            setResetLoja(false);
          }}
          isMulti
          disabled={disable.inputLoja}
          resetLojas={resetLoja}
          requiredSignal
        />

        <div className="conta-finalizadora">
          <ContaBanco
            name="cod_cc"
            placeholder="Nenhuma"
            register={register}
            control={control}
            isError={false}
            changeSelected={(selected) => {
              const { value, label, lojaId } = selected;

              setValue('cod_cc', { value, label });
            }}
            loja={loja}
            label="Conta"
            ListaWidth={isUpTo1200 ? '30rem' : '25rem'}
            disabled={disable.inputConta}
          />
          <Finalizadora
            name="cod_finalizadora"
            label="Finalizadora"
            placeholder="Todas"
            defaultLabel="Todas"
            loja={loja}
            register={register}
            control={control}
            isError={false}
            changeSelected={(selected) => {
              const { value, label, lojaId } = selected;

              setValue('cod_finalizadora', { value, label });
            }}
            disabled={disable.inputFinalizadora}
          />
        </div>
      </div>
      <div className="second-content">
        <div className="pdv-loja">
          <BuscaPdvLoja
            value={pdvSelected}
            label="PDV"
            loja={loja ?? 1}
            isDisabled={disable.inputPdv}
            placeholder={!loja ? 'Selecione a loja primeiro' : undefined}
            onChange={(val) => {
              setPdvSelected(val);
              setValue('num_pdv', val);
            }}
          />
        </div>
        <InputText
          label="Cupom Fiscal"
          placeholder="Informe o cupom fiscal"
          name="num_cupom_fiscal"
          register={register}
          isError={false}
          control={control}
          maxLength={10}
          disabled={disable.inputCupomFiscal}
        />
        <div className="input-range-emissao">
          <InputDateRange
            dataIni={emissao.ini as any}
            dataFim={emissao.fim as any}
            labelText="Emissão *"
            format="DD/MM/YYYY"
            onChange={(ini: any, fim: any) => {
              updateEmissao({ ini, fim });
            }}
            timePicker={false}
            isDisabled={disable.inputEmissao}
            key={keyRefDateRange.current}
          />
        </div>

        <SegmentedPicker
          label="Conciliados?"
          options={optionsConciliados}
          mode="single"
          selected={single}
          onChange={(v) => setSingle(v as number[])}
          id="conciliados"
          disabled={disable.conciliados}
          equalizeItemWidths={!isUpTo1200}
        />
      </div>
    </ContainerTop>
  );
};
